import { Paises } from '../interfaces/paises';

export class PaisesModel implements Paises {
    CountryCode:  string;
    Name:  string;
constructor() { }
}
